import PrivacyPolicy from "./Privacy-policy";

export default function PrivacyPage() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-12">
            <PrivacyPolicy />
        </div>
    );
}